// Variant pricing toggle - no jQuery needed
document.querySelectorAll('[data-variant-id]').forEach(input => {
  input.addEventListener('change', function () {
    const variantId = this.dataset.variantId;
    document.querySelectorAll('.variant-pricing').forEach(el => {
      el.style.display = 'none';
    });
    const active = document.querySelector(`.variant-pricing[data-varid="${variantId}"]`);
    if (active) {
      active.style.display = 'block';
    }
  });
});

// Predictive search show/hide - no jQuery needed
document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.querySelector('input[type="search"]');
  const contentWrapper = document.querySelector('.predictive-search-form__content-wrapper');
  const closeBtn = document.querySelector('.predictive-search__close-modal-button');

  if (!searchInput || !contentWrapper || !closeBtn) return;

  searchInput.addEventListener('input', function () {
    contentWrapper.classList.toggle('active', this.value.trim() !== '');
  });

  closeBtn.addEventListener('click', function () {
    searchInput.value = '';
    contentWrapper.classList.remove('active');
  });

  document.addEventListener('click', function (e) {
    const wrapper = document.querySelector('.predictive-search');
    if (wrapper && !wrapper.contains(e.target)) {
      searchInput.value = '';
      contentWrapper.classList.remove('active');
    }
  });
});
// TAB BUTTONS
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.tab-btn').forEach(function (b) {
        b.classList.remove('active');
      });
      document.querySelectorAll('.tab-content').forEach(function (c) {
        c.classList.remove('active');
      });
      btn.classList.add('active');
      var target = document.getElementById(btn.dataset.tab);
      if (target) target.classList.add('active');
    });
  });
});